/* Reuse the Fizzy icon tiles with native Teeinblue color handling. */
(() => {
  'use strict';
  if (window.FizzyNativeDoodleUi) return;
  const doc = document;
  let config;
  try { config = JSON.parse(doc.querySelector('[data-fizzy-doodle-config]')?.textContent || '{}'); }
  catch { return; }
  if (!config.nativeIconConfigs) return;
  const events = new AbortController();
  const observers = new Map();
  const runs = new Map();
  const pending = new WeakSet();
  const failed = new WeakSet();
  const dataPromises = new Map();
  function data(url) {
    if (!dataPromises.has(url)) dataPromises.set(url, fetch(url, { credentials: 'same-origin' })
      .then(response => { if (!response.ok) throw new Error('Native icon data unavailable'); return response.json(); }));
    return dataPromises.get(url);
  }
  async function activate(root) {
    if (pending.has(root) || failed.has(root)) return;
    const controls = [...root.querySelectorAll('#teeFormInputs select[id$="-template"],#teeFormInputs input[id*="-template-"]')];
    if (!controls.length) return;
    const artworkId = controls.map(control => control.id.split('-template')[0])
      .find(id => Object.hasOwn(config.nativeIconConfigs, id));
    if (!artworkId) return;
    pending.add(root);
    try {
      const entry = await data(config.nativeIconConfigs[artworkId]);
      if (!root.isConnected) return;
      if (entry.native !== true || !entry.artworkIds?.map(String).includes(artworkId)) throw new Error('Mismatched native icon data');
      const key = entry.artworkIds.join(',');
      const ui = await window.FizzyIconLoader.loadPresentation(doc, config);
      if (!root.isConnected) return;
      if (!runs.has(key)) runs.set(key, ui.mount(doc, { ...entry, strings: config.iconStrings }, []));
      observers.get(root)?.disconnect(); observers.delete(root);
    } catch {
      // Retain the complete native form on missing data or UI assets. Never block ATC.
      failed.add(root);
      root.dataset.fizzyGalleryPresentation = 'fallback';
      root.dispatchEvent(new Event('fizzy:gallery-presentation-ready'));
    } finally { pending.delete(root); }
  }
  function scan() {
    for (const [root, observer] of observers) if (!root.isConnected) { observer.disconnect(); observers.delete(root); }
    for (const root of doc.querySelectorAll('[data-teeinblue-pdp]')) {
      if (!observers.has(root)) {
        const Observer = window.FizzyProductObserver?.Observer || MutationObserver;
        const observer = new Observer(() => { void activate(root); });
        observer.observe(root, { childList: true, subtree: true });
        observers.set(root, observer);
      }
      void activate(root);
    }
  }
  doc.addEventListener('teeinblue-event-component-injected', scan, { signal: events.signal });
  doc.addEventListener('shopify:section:load', scan, { signal: events.signal });
  doc.addEventListener('shopify:section:unload', event => {
    for (const [root, observer] of observers) if (event.target.contains(root)) { observer.disconnect(); observers.delete(root); }
  }, { signal: events.signal });
  window.FizzyNativeDoodleUi = { runs, destroy() {
    events.abort(); for (const observer of observers.values()) observer.disconnect();
    for (const run of runs.values()) run.destroy(); observers.clear(); runs.clear();
    delete window.FizzyNativeDoodleUi;
  } };
  scan();
})();
